/**
 * @file PC 平台策略
 * @description 继承 H5 基础实现，仅重写差异方法
 */

import { createH5Strategy } from './h5'
import { PlatformType, type IPlatformStrategy, type LoginOptions } from '../types'
import { removePubParamsOfUrl } from '@h5-journey/utils'

/**
 * PC 策略：继承 H5 基础实现，仅重写差异方法
 * - navigateTo: PC 端默认行为与 H5 一致，特殊需求时重写
 * - toLogin: PC 端登录跳转路径可能不同
 * - 其他方法默认复用 H5 实现
 */
export function createPCStrategy(): IPlatformStrategy {
  const h5 = createH5Strategy()

  return {
    ...h5,
    type: PlatformType.PC,
    navigation: {
      ...h5.navigation,
      // PC 登录跳转路径可能不同于 H5
      async toLogin(options: LoginOptions = {}) {
        // 与 H5 对齐：清理 URL 公共参数，支持自定义登录页路径
        const returnUrl = removePubParamsOfUrl(options.returnUrl || window.location.href)
        const loginPath = options.loginPath || '/login'
        const base = (import.meta.env.VITE_BASE_URL || '/').replace(/\/$/, '')
        window.location.replace(
          `${base}${loginPath}?url=${encodeURIComponent(returnUrl)}`
        )
      }
    }
    // communication 复用 H5 实现，无需重写
  }
}
